/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cascade_Dialog_Error_Group_Count_RequiredInputs */



/**
* | output |
* | --- |
* | "The number of groups is required in auto mode" |
*
* @param {Cascade_Dialog_Error_Group_Count_RequiredInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const cascade_dialog_error_group_count_required = /** @type {((inputs?: Cascade_Dialog_Error_Group_Count_RequiredInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cascade_Dialog_Error_Group_Count_RequiredInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The number of groups is required in auto mode")
	return /** @type {LocalizedString} */ ("Le nombre de groupes est requis en mode auto")
});